export function getPostAJobPageUrl()
{
  return window.$jBoard.urls.post_a_job_url;
}

export function getEmployerAccountJobPageUrl()
{
  return window.$jBoard.urls.employer_account_jobs_page_url;
}
